import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Layout, Grid, theme, Button, Flex } from "antd";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import NavMenu from "./navMenu/NavMenu";
import BurgerMenu from "./burgerMenu/BurgerMenu";
import HeaderSearch from "./headerSearch/HeaderSearch";
import "./appHeader.css";
const { useBreakpoint } = Grid;
const { Header } = Layout;
const AppHeader = forwardRef(
  ({
    showSelectLanguage = true,
    additionalNavigationItem = null,
    drawerOpened,
    setDrawerOpened,
    menuItems,
    burgerMenuItems,
    loginButton = null,
    topBanner = null,
    children
  }, ref) => {
    const screens = useBreakpoint();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { token } = theme.useToken();
    const logoRef = useRef(null);
    const [logoWidth, setLogoWidth] = useState("max-content");
    const showCloseButton = !screens.md && pathname.includes("/search");
    useEffect(() => {
      var _a;
      setLogoWidth(((_a = logoRef.current) == null ? void 0 : _a.offsetWidth) || "max-content");
    }, [children]);
    const toggleDrawer = () => setDrawerOpened(!drawerOpened);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        className: "app-header",
        style: {
          backgroundColor: token.colorBgBase,
          boxShadow: token.boxShadow,
          position: "fixed",
          zIndex: 1060,
          top: "env(safe-area-inset-top, 0)",
          left: 0,
          right: 0
        },
        children: [
          topBanner,
          /* @__PURE__ */ jsxs(
            Header,
            {
              style: {
                position: "relative",
                height: !screens.lg ? 60 : 96,
                backgroundColor: token.colorBgContainer,
                display: "flex",
                alignItems: "center",
                padding: 0
              },
              children: [
                showCloseButton ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "text",
                    className: "close-button",
                    icon: /* @__PURE__ */ jsx(
                      CloseOutlined,
                      {
                        style: {
                          fontSize: 24,
                          color: token.colorLinkActive
                        }
                      }
                    ),
                    onClick: () => navigate(-1),
                    style: {
                      color: token.colorTextBase,
                      position: "absolute",
                      left: 24,
                      zIndex: 1060
                    }
                  }
                ) : !screens.lg ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "text",
                    className: "close-button",
                    icon: drawerOpened ? /* @__PURE__ */ jsx(
                      CloseOutlined,
                      {
                        style: {
                          fontSize: 24,
                          color: token.colorLinkActive
                        }
                      }
                    ) : /* @__PURE__ */ jsx(MenuOutlined, { style: { fontSize: 24 } }),
                    onClick: toggleDrawer,
                    style: {
                      color: token.colorTextBase,
                      position: "absolute",
                      left: 24,
                      zIndex: 1060
                    }
                  }
                ) : null,
                /* @__PURE__ */ jsx("div", { className: "container", children: /* @__PURE__ */ jsxs(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      padding: !screens.lg ? "0 24px" : screens.xxl ? 0 : "0 40px",
                      height: !screens.lg ? 60 : 96,
                      position: "relative"
                    },
                    children: [
                      /* @__PURE__ */ jsx(
                        Link,
                        {
                          ref: logoRef,
                          to: "/",
                          style: {
                            display: "flex",
                            alignItems: "center",
                            position: !screens.lg ? "absolute" : "unset",
                            left: !screens.lg ? "50%" : "0",
                            transform: !screens.lg ? "translateX(-50%)" : "none"
                          },
                          children
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        NavMenu,
                        {
                          menuItems,
                          drawerOpened
                        }
                      ),
                      /* @__PURE__ */ jsxs(
                        Flex,
                        {
                          className: "app-header_actions-menu",
                          gap: !screens.lg ? 16 : 24,
                          style: {
                            // minWidth (not width) lets the actions grow when
                            // the search field expands, pushing the nav left
                            minWidth: screens.lg && logoWidth ? logoWidth : "max-content",
                            justifyContent: "flex-end",
                            marginLeft: !screens.lg ? "auto" : "unset"
                          },
                          align: "center",
                          children: [
                            screens.lg && additionalNavigationItem,
                            /* @__PURE__ */ jsx(HeaderSearch, { mobile: !screens.lg }),
                            loginButton,
                            screens.lg && /* @__PURE__ */ jsx(
                              BurgerMenu,
                              {
                                menuItems: burgerMenuItems,
                                showSelectLanguage
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                ) })
              ]
            }
          )
        ]
      }
    );
  }
);
var stdin_default = memo(AppHeader);
export {
  stdin_default as default
};
